import type { TypeRegionSkeleton } from './TypeRegion'

import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypePageFields {
  name?: EntryFieldTypes.Symbol
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  thumbnail?: EntryFieldTypes.AssetLink
  hero?: EntryFieldTypes.AssetLink
  slug: EntryFieldTypes.Symbol
  body: EntryFieldTypes.RichText
  region: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeRegionSkeleton>>
}

export type TypePageSkeleton = EntrySkeletonType<TypePageFields, 'page'>
export type TypePage<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypePageSkeleton,
  Modifiers,
  Locales
>

export function isTypePage<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypePage<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'page'
}

export interface TypePageV2Fields {
  name?: EntryFieldTypes.Symbol
  thumbnail?: EntryFieldTypes.AssetLink
  slug: EntryFieldTypes.Symbol
}

export type TypePageV2Skeleton = EntrySkeletonType<TypePageFields, 'page'>
export type TypePageV2<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypePageSkeleton,
  Modifiers,
  Locales
>

export function isTypePageV2<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypePage<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'page-v2'
}
